import { Course } from '../tlh_courses/course-types';
import { GradeBoosterRef } from 'src/app/types/user-types';
import { Campaign } from 'src/app/types/campaign-types';

export type MenuItemViewModel = {
  id?: string | number;
  icon: string;
  iconType: 'material' | 'image';
  /**
   * A single-color outline icon whose color should follow the item's
   * text color (grey when idle, brand teal when active/selected) instead
   * of rendering the image's own baked-in colors — applied via CSS mask.
   */
  monochrome?: boolean;
  title: string;
  tooltip?: string;
  url?: string;
  lockedUrl?: string;
  completionPercentage?: number;
  locked: boolean;
  pill?: string;
  children?: { title: string; url: string }[];
  featured?: boolean;
};

export type MenuSectionConfig = {
  key: string;
  items: MenuItemViewModel[];
  searchable?: boolean;
  searchPlaceholder?: string;
};

export type FeatureItemDef = {
  displayName: string;
  tooltip: string;
  icon: string;
  materialIcon: boolean;
  monochrome?: boolean;
  url: string;
  pill?: string;
  children?: { displayName: string; url: string }[];
  featured?: boolean;
};

export function featureToViewModel(
  item: FeatureItemDef,
  locked: boolean,
): MenuItemViewModel {
  return {
    icon: item.icon,
    iconType: item.materialIcon ? 'material' : 'image',
    monochrome: item.monochrome,
    title: item.displayName,
    tooltip: item.tooltip || undefined,
    url: item.url,
    locked,
    pill: item.pill,
    featured: (item as any).featured,
    children: item.children?.map((c) => ({ title: c.displayName, url: c.url })),
  };
}

export function courseToViewModel(
  course: Course & { completion_percentage?: number },
  locked: boolean,
): MenuItemViewModel {
  const rawIcon = course.icon;
  const icon =
    typeof rawIcon === 'object' && rawIcon !== null
      ? (rawIcon as { link: string }).link
      : (rawIcon as string) || 'assets/images/course-placeholder.svg';

  return {
    id: course.id,
    icon,
    iconType: 'image',
    title: course.title,
    url: `/course-lessons/${course.id}`,
    lockedUrl: '/membership',
    completionPercentage: locked ? undefined : course.completion_percentage,
    locked,
  };
}

export function campaignToViewModel(campaign: Campaign): MenuItemViewModel {
  return {
    id: campaign.id,
    icon: 'campaign',
    iconType: 'material',
    title: campaign.menu_title,
    url: `/campaigns/${campaign.id}`,
    locked: false,
  };
}

export function gradeBoosterToViewModel(
  gb: GradeBoosterRef & { icon: string; completion_percentage?: number },
): MenuItemViewModel {
  return {
    id: gb.id,
    icon: gb.icon,
    iconType: 'image',
    title: gb.title,
    url: `/grade-booster/${gb.id}`,
    completionPercentage: gb.completion_percentage,
    locked: false,
  };
}
